import React from 'react';
import styled from 'styled-components';
import { ParagraphProps } from '../Paragraph';
import { Icon } from '../Icon';
import { Link } from '../Link';

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-wrap: nowrap;
`;

export type StyledDownloadBrochureLinkProps = {
  to?: string;
  newTab?: boolean;
  download?: boolean;
} & ParagraphProps;

export const StyledDownloadBrochureLink = ({
  to,
  newTab,
  text,
  download,
}: StyledDownloadBrochureLinkProps) => {
  return (
    <LinkWrapper>
      <Icon matIcon="download_for_offline" outlined />
      <Link
        to={to}
        target={newTab ? '_blank' : undefined}
        label={text}
        download={download}
      />
    </LinkWrapper>
  );
};
